/* LeParfin : page Sélection (maquette V3, fonction trio ; V4 avec quantités).
   Chaque carte a un compteur + et moins : le même parfum peut être pris plusieurs fois (5 au plus).
   Barre collante à 5 cases (3e et 5e offertes), total en direct, ajout au panier via window.LP.cart.add. */
(() => {
  'use strict';

  /* ---------- Logique pure (testable sans navigateur) ---------- */
  const Sel = {
    MAX: 5,
    counts(units) {
      const c = {};
      units.forEach(k => { c[k] = (c[k] || 0) + 1; });
      return c;
    },
    add(units, key, max) {
      const m = max || Sel.MAX;
      return units.length < m ? units.concat([key]) : units.slice();
    },
    remove(units, key) {
      const u = units.slice();
      const i = u.lastIndexOf(key);
      if (i > -1) u.splice(i, 1);
      return u;
    },
    /* Unités regroupées par parfum, dans l'ordre de première apparition (affichage des cases). */
    grouped(units) {
      const keys = units.filter((k, i) => units.indexOf(k) === i);
      const out = [];
      keys.forEach(k => units.forEach(x => { if (x === k) out.push(k); }));
      return out;
    },
    freeCount(n) {
      return n >= 5 ? 2 : n >= 3 ? 1 : 0;
    },
    /* Total : les moins chers sont offerts ; le prix barré est la somme des parfums (la pochette offerte n'est pas comptée). */
    totals(units, priceOf, pochette) {
      const n = units.length;
      const free = Sel.freeCount(n);
      const prices = units.map(k => Number(priceOf(k)) || 0);
      const sum = prices.reduce((a, b) => a + b, 0);
      const offered = prices.slice().sort((a, b) => a - b).slice(0, free).reduce((a, b) => a + b, 0);
      return { n, free, pay: sum - offered, full: sum };
    },
    message(n, L) {
      if (n < 3) return 3 - n > 1 ? String(L.needMany || '').replace('[n]', 3 - n) : (L.needOne || '');
      if (n === 3) return L.three || '';
      if (n === 4) return L.four || '';
      return L.five || '';
    },
    items(units, variantOf) {
      const out = [];
      units.forEach(k => {
        const id = Number(variantOf(k));
        if (!id) return;
        const line = out.find(x => x.id === id);
        if (line) line.quantity += 1; else out.push({ id, quantity: 1 });
      });
      return out;
    }
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module !== 'undefined' && module.exports) module.exports = { Sel };
    return;
  }

  const fallbackMoney = cents => (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  const money = cents => (window.LP && typeof window.LP.money === 'function' ? window.LP.money(cents) : fallbackMoney(cents));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function addToCart(items) {
    if (window.LP && window.LP.cart && typeof window.LP.cart.add === 'function') return window.LP.cart.add(items, { open: true });
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    }).then(r => { if (!r.ok) throw new Error('cart'); window.location.href = root + 'cart'; });
  }

  function setup(root) {
    if (!root || root.__lpSel) return;
    const dataEl = root.querySelector('[data-lp-selection-data]');
    if (!dataEl) return;
    let cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.__lpSel = true;

    const L = cfg.labels || {};
    const P = cfg.perfumes || {};
    const slotsEl = root.querySelector('[data-lp-slots]');
    const msgEl = root.querySelector('[data-lp-tray-msg]');
    const addBtn = root.querySelector('[data-lp-tray-add]');
    const cards = [...root.querySelectorAll('[data-lp-card]')];
    const okKey = k => !!(P[k] && P[k].variant);
    let sel = [];
    let busy = false;

    document.body.classList.add('has-tray');

    function render(focusKey) {
      const t = Sel.totals(sel, k => P[k] && P[k].price, cfg.pochette);
      const c = Sel.counts(sel);
      const full = t.n >= Sel.MAX;

      cards.forEach(card => {
        const k = card.getAttribute('data-lp-card');
        const q = c[k] || 0;
        const addB = card.querySelector('.lp-card-add');
        const step = card.querySelector('.lp-step');
        const out = card.querySelector('[data-lp-n]');
        const badge = card.querySelector('[data-lp-badge]');
        const hadFocus = step && step.contains(document.activeElement);
        card.classList.toggle('on', q > 0);
        card.classList.toggle('sel-on', q > 0);
        if (addB) { addB.hidden = q > 0; addB.disabled = !okKey(k) || full; }
        if (step) {
          step.hidden = q === 0;
          const minus = step.querySelector('[data-lp-minus]');
          const plus = step.querySelector('[data-lp-plus]');
          if (minus) minus.disabled = q === 0;
          if (plus) plus.disabled = !okKey(k) || full;
        }
        if (out) out.textContent = String(q);
        if (badge) badge.textContent = q ? '×' + q : '';
        /* Le focus suit le passage bouton d'ajout vers compteur, et inversement. */
        if (focusKey === k) {
          if (q > 0 && step && !hadFocus) { const p = step.querySelector('[data-lp-plus]'); if (p && !p.disabled) p.focus(); else if (step.querySelector('[data-lp-minus]')) step.querySelector('[data-lp-minus]').focus(); }
          if (q === 0 && addB && !addB.disabled) addB.focus();
        }
      });

      if (slotsEl) {
        const g = Sel.grouped(sel);
        slotsEl.innerHTML = [0, 1, 2, 3, 4].map(i => {
          const k = g[i];
          const gift = i === 2 || i === 4;
          if (k) {
            const p = P[k] || {};
            const label = String(L.remove || '').replace('[nom]', p.cap || '');
            return `<button class="slot full${gift ? ' g' : ''}" type="button" data-p="${esc(k)}" data-lp-del="${esc(k)}"${gift ? ` data-l="${esc(L.free)}"` : ''} aria-label="${esc(label)}"><img src="${esc(p.img)}" alt="" width="48" height="48"></button>`;
          }
          return `<span class="slot${gift ? ' g' : ''}">${gift ? esc(L.free) : i + 1}</span>`;
        }).join('');
      }

      if (msgEl) {
        msgEl.innerHTML = Sel.message(t.n, L) + (t.n ? ` · <span class="lp-nw"><b>${esc(money(t.pay))}</b>${t.free ? ` <s>${esc(money(t.full))}</s>` : ''}</span>` : '');
      }

      if (addBtn) {
        addBtn.disabled = t.n < 3 || busy;
        addBtn.textContent = t.n >= 3 ? String(L.addN || '').replace('[n]', t.n) : L.add;
      }
    }

    function pop(card) {
      if (reduced() || !card) return;
      const b = card.querySelector('[data-lp-badge]');
      if (!b || !b.animate) return;
      b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'ease-out' });
    }

    root.addEventListener('click', e => {
      const plus = e.target.closest('[data-lp-plus]');
      const minus = e.target.closest('[data-lp-minus]');
      const card = (plus || minus) && (plus || minus).closest('[data-lp-card]');
      if (card && root.contains(card)) {
        e.preventDefault();
        const k = card.getAttribute('data-lp-card');
        if (plus) {
          if (!okKey(k) || sel.length >= Sel.MAX) return;
          sel = Sel.add(sel, k);
          render(k);
          pop(card);
        } else {
          sel = Sel.remove(sel, k);
          render(k);
        }
        return;
      }
      const del = e.target.closest('[data-lp-del]');
      if (del && root.contains(del)) {
        e.preventDefault();
        sel = Sel.remove(sel, del.getAttribute('data-lp-del'));
        render();
        return;
      }
      const add = e.target.closest('[data-lp-tray-add]');
      if (add && root.contains(add)) {
        e.preventDefault();
        if (busy || sel.length < 3) return;
        const items = Sel.items(sel, k => P[k] && P[k].variant);
        if (!items.length) return;
        busy = true;
        render();
        Promise.resolve(addToCart(items))
          .then(() => { busy = false; sel = []; render(); })
          .catch(() => {
            busy = false;
            render();
            /* Avec theme.js, LP.cart.add affiche déjà le message de la boutique ; sinon message de secours. */
            const hasCart = !!(window.LP && window.LP.cart && typeof window.LP.cart.add === 'function');
            if (!hasCart && msgEl) msgEl.textContent = L.error || '';
          });
      }
    });

    render();
  }

  const init = (scope = document) => {
    if (scope.matches && scope.matches('[data-lp-selection]')) setup(scope);
    scope.querySelectorAll('[data-lp-selection]').forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    if (e.target.querySelector('[data-lp-selection]')) document.body.classList.remove('has-tray');
  });
})();
